module.exports = __webpack_public_path__ + "static/media/tiago_fogaca_marangoni.437a1a68.png";